import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import {FormBuilder, FormGroup, FormsModule, Validators,FormControl} from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA,MatTableDataSource } from '@angular/material';
import {ImpuestosReteidos} from '../../../models/impuestosRetenidos'


@Component({
    selector: 'app-impuestosRetenidos',
    styleUrls: [],
    templateUrl: 'impuestosRetenidos.component.html',
    providers: [generalService]
  })


export class modalImpuestosRetendidos implements OnInit{
    constructor(public dataService: DataService,
        private dialogRef: MatDialogRef<modalImpuestosRetendidos>, 
        @Inject(MAT_DIALOG_DATA) data,
        public _generalService: generalService,
        private formBuilder: FormBuilder
    ) {}


    public displayedColumns: string[] = [
        'acciones',
        'base',
        'impuestos',
        'tasaCuota',
        'valorTasaCuota',
        'importe',
    ]

    tasaCuota =[
        {TAX_TYPE: 'T', value: 'Tasa'},
        {TAX_TYPE: 'C', value: 'Cuota'}
    ]

    public lista_ImpuestosRetenidos:any [] = [];
    listaDetalleImpuestosRetenidos: ImpuestosReteidos[] = [];
    listaImpuestosRetenidos: ImpuestosReteidos[] = [];
    listaAgregar: ImpuestosReteidos[] = [];
    public btncerrar = false;
    public list_bill_tax:any [] = [];
    public list_bill_detail_tax :any [] = [];

    public dataSource = new MatTableDataSource<ImpuestosReteidos>();
    public impuestosRetenidos: ImpuestosReteidos =  new ImpuestosReteidos();
    public baseControl = new FormControl({ value: null, disabled: true });
    public tasaCuotaControl =  new FormControl(null, [Validators.required]);
    public impuestoControl =  new FormControl(null, [Validators.required]);
    public valorTasaCuotaControl =  new FormControl(null, [Validators.required]);
    public importeCuotaControl = new FormControl(null);

    private formularioValido = true;
    public seEstaAgregando = false;
    public seEstaEditando = false;
    public transaccionEnCurso = false;
    public edicionBorrar = false;
    public baseImpuestosRetenidos = 0;
    public base = 0;
    valorTasaCuota: string = '';
    valorTasaCoutaAnterior = 0;

    public msjSatisfaction ='';
    public valorTC = "";
    public btnGuardar = true;

    public totalImpuestosRetenidos = 0;
    

    ngOnInit() { 
        this.getDataImpuestosRetenidos(this.dataSource);
        this.dataFactura();
        this.setValueEdit();
    }
    dataFactura(){
       
        // Converti la cadena a un número y redondearlo a dos decimales
        const baseFacturaNumerico = parseFloat(this.dataService.dialogRef._containerInstance._config.data.baseFactura);
        const baseFacturaRedondeado = parseFloat(baseFacturaNumerico.toFixed(2));

        // Asignar el valor redondeado a this.baseImpuestosRetenidos y this.base
        this.baseImpuestosRetenidos = baseFacturaRedondeado;
        this.base = baseFacturaRedondeado;

    }
  
    cerrarModal() {
        this.dataService.dialogRef.close();
    }


    getDataImpuestosRetenidos(id: any){
        this.listaImpuestosRetenidos = [];
        let metodo = 'factura/getDataImpuestosRetenidos';
        const params = {
            BILL_DETAIL_ID: this.dataService.dialogRef._containerInstance._config.data.BILL_DETAIL_ID, 
            loacs: sessionStorage.getItem('acslo'),
        };

        this._generalService.metodoCallParams(params, metodo).subscribe(
            (result) => {
                const tableResult = JSON.parse(result);
                this.list_bill_tax = tableResult.Table;
                this.list_bill_detail_tax =  tableResult.Table1;
                
                if( this.list_bill_detail_tax.length > 0){
                    //this.listaImpuestosRetenidos = [];
                    this.totalImpuestosRetenidos = 0;
                    const seenIds = new Set<string>();

                    for (let i = 0; i < this.list_bill_detail_tax.length; i++) {
                        const billDetailTaxId = this.list_bill_detail_tax[i].BILL_DETAIL_TAX_ID;

                        if (!seenIds.has(billDetailTaxId)) {
                            this.list_bill_detail_tax[i].index = i;
                            seenIds.add(billDetailTaxId);

                            const modeloAuxiliar: any = {
                                index: i,
                                BILL_DETAIL_TAX_ID: billDetailTaxId,
                                BILL_DETAIL_ID: this.list_bill_detail_tax[i].BILL_DETAIL_ID,
                                BASE: this.list_bill_detail_tax[i].BASE,
                                BILL_TAX_ID: this.list_bill_detail_tax[i].BILL_TAX_ID,
                                TAX_TYPE: this.list_bill_detail_tax[i].TAX_TYPE,
                                TAX_TYPEValue: this.list_bill_detail_tax[i].TAX_TYPEValue,
                                TAX_VALUE: this.list_bill_detail_tax[i].TAX_VALUE,
                                BILL_TAX_IDValue: this.list_bill_detail_tax[i].BILL_TAX_IDValue,
                                AMOUNT: this.list_bill_detail_tax[i].AMOUNT,
                            };

                            // Verificamos si este BILL_DETAIL_TAX_ID ya está en listaImpuestosRetenidos
                            const alreadyAdded = this.listaImpuestosRetenidos.some(item => item.BILL_DETAIL_TAX_ID === billDetailTaxId);
                            if (!alreadyAdded) {
                                this.listaImpuestosRetenidos.push(modeloAuxiliar);
                            }
                        }
                    }
                    
                    this.dataSource.data = this.listaImpuestosRetenidos;
                    this.listaImpuestosRetenidos.forEach((impuesto) => {
                        this.totalImpuestosRetenidos += impuesto.AMOUNT;
                    });

                    if (this.dataSource.data.length > 0) {
                        this.btnGuardar = false;
                    }
                }else{
                    if(this.listaImpuestosRetenidos.length == 0){
                        this.dataSource.data= this.listaImpuestosRetenidos = [];
                    }
                }
                
                
               
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
        );
    }

    setAccionAgregar(value:number) {
        this.edicionBorrar = true;
        this.establecerValoresPorDefecto();    
        this.seEstaEditando = false;
        this.seEstaAgregando = true;
        this.baseControl.setValue(this.base);
        this.valorTasaCuota = '';
    }
    cancelarAccion() {
        this.edicionBorrar = false;
        this.establecerValoresPorDefecto();
        this.valorTasaCuota = '';
    }
    validarFormulario() {
        this.formularioValido = false;
        const campoRequerido = 'Favor de llenar los campos requeridos';
        this.resaltarCamposConErrores();
        if (
            this.baseControl.invalid ||
            this.tasaCuotaControl.invalid ||
            this.impuestoControl.invalid ||
            this.valorTasaCuotaControl.invalid ||
            this.importeCuotaControl.invalid
            
            
        ) {
            this._generalService.toastCall(campoRequerido);
            return;
        }
        
        this.formularioValido = true;
        
    }

    resaltarCamposConErrores() {
        this.baseControl.markAsTouched();
        this.tasaCuotaControl.markAsTouched();
        this.impuestoControl.markAsTouched();
        this.valorTasaCuotaControl.markAsTouched();
        this.importeCuotaControl.markAsTouched();
        
    }

    mapearDatosFormControl() {
        this.impuestosRetenidos.BASE = this.baseControl.value;
        this.impuestosRetenidos.TAX_TYPE = this.tasaCuotaControl.value;
        const tasCuota = this.tasaCuota.find((tc) => tc.TAX_TYPE === this.impuestosRetenidos.TAX_TYPE); 
        if (tasCuota !== null && tasCuota !== undefined){
            this.impuestosRetenidos.TAX_TYPEValue = tasCuota.value
        }
        
        this.impuestosRetenidos.BILL_TAX_ID = this.impuestoControl.value;
        const impuesto = this.list_bill_tax.find((i) => i.BILL_TAX_ID === this.impuestosRetenidos.BILL_TAX_ID); 
        if (impuesto !== null && impuesto !== undefined){
            this.impuestosRetenidos.BILL_TAX_IDValue = impuesto.BILL_TAX_KEY + " " + impuesto.NAME;
        }
        this.impuestosRetenidos.TAX_VALUE = this.valorTasaCuotaControl.value;
        this.impuestosRetenidos.AMOUNT = this.importeCuotaControl.value;
        
    }

    establecerImpuestosRetenidos(impuestosRetenidos: ImpuestosReteidos) {
        this.impuestosRetenidos = new ImpuestosReteidos();
        this.seEstaEditando = true;
        this.impuestosRetenidos = impuestosRetenidos;
        this.transaccionEnCurso = true;
        this.baseControl.setValue(impuestosRetenidos.BASE);
        this.tasaCuotaControl.setValue(impuestosRetenidos.TAX_TYPE);
        this.impuestoControl.setValue(impuestosRetenidos.BILL_TAX_ID);
        this.valorTasaCuotaControl.setValue(impuestosRetenidos.TAX_VALUE);
        this.importeCuotaControl.setValue(impuestosRetenidos.AMOUNT);
        
        
    }

    establecerValoresPorDefecto() {
        this.impuestosRetenidos = new ImpuestosReteidos();
        this.seEstaEditando = false;
        this.seEstaAgregando = false;
        this.baseControl.reset();
        this.tasaCuotaControl.reset();
        this.impuestoControl.reset();
        this.valorTasaCuotaControl.reset();
        this.importeCuotaControl.reset();
        
    }
    guardarImpuestosRetenidosHeader() {
        this.edicionBorrar = false;
        this.validarFormulario();
        if (this.formularioValido) {
            this.mapearDatosFormControl();
            this.agregarImpuestosRetenidos();
        }
        this.calculoImpuestosRetenidos();
    }
  
    agregarImpuestosRetenidos() {
        let index = 0;
        
        this.lista_ImpuestosRetenidos = this.listaImpuestosRetenidos;
        this.listaDetalleImpuestosRetenidos = this.lista_ImpuestosRetenidos;
        if (this.listaDetalleImpuestosRetenidos.length === 0) {
             index = 0;
        } else {
             index = this.listaDetalleImpuestosRetenidos.length;
        }
        this.impuestosRetenidos.index = index;
        this.listaDetalleImpuestosRetenidos[index] = this.impuestosRetenidos;
        this.listaImpuestosRetenidos = this.listaDetalleImpuestosRetenidos;
        this.seEstaEditando = false;
        setTimeout( () => {
            this.dataSource.data = this.listaImpuestosRetenidos;
            this.establecerValoresPorDefecto();
        });  

        if(this.dataSource.data.length > 0){
            this.btnGuardar = false;
        }
       
    }
    eliminarRow(element){
        this.btncerrar = true;
        this.listaDetalleImpuestosRetenidos;
        const index = this.listaImpuestosRetenidos.findIndex((obj) => obj.index === element.index);
        if (element.BILL_DETAIL_TAX_ID !== null && element.BILL_DETAIL_TAX_ID !== undefined) {
            
            this.eliminarImpuestosRetendosDB(this.listaImpuestosRetenidos[index]);
        } else {
            this.eliminar(element.index);
       }
       
        

        
    }
    eliminar(id) {
        const index = this.listaImpuestosRetenidos.findIndex((element) => element.index === id);
        this.listaImpuestosRetenidos.splice(index, 1);
        this.listaAgregar.splice(index, 1);
        setTimeout( () => {
            this.dataSource.data = this.listaImpuestosRetenidos;
        });
        this.calculoImpuestosRetenidos();
    }
    eliminarImpuestosRetendosDB(impuestosRetenidos: ImpuestosReteidos){
        const metodo = 'factura/deleteImpuestosRetendios';
        this._generalService.metodoCallParams(impuestosRetenidos, metodo).subscribe(
            (result) => {
                this._generalService.toastCall('Se ha eliminado el renglon exitosamente!');
                this.getDataImpuestosRetenidos(this.dataSource);

                this.calculoImpuestosRetenidos();
            },
            (error) => {
            const errorMsj =  error as any;
            console.log(errorMsj);
            }
        );
        
    }
    
    establecerDetalle(impuestosRetenidos: ImpuestosReteidos){
        this.impuestosRetenidos = new ImpuestosReteidos();
        this.seEstaEditando = true;
  
        this.impuestosRetenidos = impuestosRetenidos;
        this.transaccionEnCurso = true;
        this.baseControl.setValue(impuestosRetenidos.BASE);
        this.tasaCuotaControl.setValue(impuestosRetenidos.TAX_TYPE);
        this.impuestoControl.setValue(impuestosRetenidos.BILL_TAX_ID);
        this.valorTasaCuotaControl.setValue(impuestosRetenidos.TAX_VALUE);
        this.valorTC =  this.valorTasaCuotaControl.value;
        this.importeCuotaControl.setValue(impuestosRetenidos.AMOUNT);
        
        
        this.transaccionEnCurso = false;
    }

    guardarDetalleRow() {
        this.edicionBorrar = false;
        this.validarFormulario();
        if (this.formularioValido) {
            this.mapearDatosFormControl();
            this.editarDetalleImpuestosRetenidos();
        }
        this.calculoImpuestosRetenidos();
    }

    editarDetalleImpuestosRetenidos() {
        var index: any = 0;
        this.lista_ImpuestosRetenidos = this.listaImpuestosRetenidos;
        this.listaDetalleImpuestosRetenidos = this.lista_ImpuestosRetenidos;
        this.listaDetalleImpuestosRetenidos.forEach(element => {
        if(element.index == this.impuestosRetenidos.index){
            index = element.index;
            return;
        }
        });

        this.impuestosRetenidos.index = index;
        this.listaDetalleImpuestosRetenidos[index] = this.impuestosRetenidos;
    
        this.listaImpuestosRetenidos = this.listaDetalleImpuestosRetenidos;
        this.seEstaEditando = false;
        setTimeout( () => {
          this.dataSource.data = this.listaImpuestosRetenidos;
         
        });
    }
    guardarImpuestosRetenidos(){
        
        const params = {
            impuestosRetenidosData: this.dataSource.filteredData,
            totalImpuestosRetenidos: this.totalImpuestosRetenidos,
            indexFacturaDetalle : this.dataService.dialogRef._containerInstance._config.data.indexFactura,
        };

        params
        // regresar impuestos
        this.dataService.dialogRef.close(params);

    }

    calculoImporte(val: any) {
        let valor = val.key;
        let bandera = true;
        let importeCalculo = 0;
    
        if (this.valorTC === "") {
            if (!isNaN(Number(valor)) || valor === '.') {
                this.valorTasaCuota += valor.toString();
            } else if (valor === 'Backspace') {
                this.valorTasaCuota = this.valorTasaCuota.slice(0, -1);
            }
    
            let valorTasaCuotaNumero: number = parseFloat(this.valorTasaCuota);
            importeCalculo = valorTasaCuotaNumero * this.base;
        } else {
            if (!isNaN(Number(valor)) || valor === '.') {
                this.valorTC += valor.toString();
                bandera = false;
            } else if (valor === 'Backspace') {
                if (bandera) {
                    this.valorTC = this.valorTC.toString().slice(0, -1);
                } else {
                    this.valorTC = this.valorTC.slice(0, -1);
                }
            }
    
            let valorTCNumero: number = parseFloat(this.valorTC);
            importeCalculo = valorTCNumero * this.base;
        }
    
        this.importeCuotaControl.setValue(importeCalculo);
    }
    
    
    

    calculoImpuestosRetenidos(){
        this.totalImpuestosRetenidos = 0
        this.listaImpuestosRetenidos;
        let totalSum = 0;
        this.listaImpuestosRetenidos.forEach(elemento => {   
            totalSum += elemento.AMOUNT;
        });
        this.totalImpuestosRetenidos = totalSum;
    }

    
    setValueEdit(){

        if(this.dataService.dialogRef._containerInstance._config.data.impuestosRetenidosEdit.impuestoRetenido !== undefined){
            this.listaImpuestosRetenidos = this.dataService.dialogRef._containerInstance._config.data.impuestosRetenidosEdit.impuestoRetenido.impuestosRetenidosData;
            this.totalImpuestosRetenidos = this.dataService.dialogRef._containerInstance._config.data.impuestosRetenidosEdit.impuestoRetenido.totalImpuestosRetenidos;
        }

        this.listaImpuestosRetenidos ;
        this.dataSource.data = this.listaImpuestosRetenidos

        if(this.dataSource.data.length > 0){
            this.btnGuardar = false;
        }
    }
}  


// WEBPACK FOOTER //
// ./src/app/factura/agregar-editar/impuestosRetenidos/impuestosRetenidos.component.ts